import { addSystemLog } from '@/api/systemLog'
import store from '@/store'

// 记录操作日志，username 自动取当前登录账号
export function recordLog({ event, customername, api, details }) {
  const data = {
    username: store.getters.name || '',
    interface: api || '',
    event: event || '',
    customername: customername || '',
    details: details || ''
  }
  return addSystemLog(data).catch(err => {
    console.error('日志记录失败', err)
  })
}
